import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import actions from './actions';
import * as mockTestService from '@iso/services/mockTest';

export function* getSampleExam() {
	yield takeEvery(actions.GET_SAMPLE_EXAM, function* ({ payload }) {
		const { model } = payload;
		try {
			const response = yield call(mockTestService.getSampleExam, model);
			if (response.data.success === true) {
				const { data } = response.data;
				yield put({
					type: actions.GET_SAMPLE_EXAM_SUCCESS,
					payload: { data },
				});
			}
		} catch (e) {
			yield put({ type: actions.LOADING_FALSE });
		}
	});
}

export function* getSampleExamById() {
	yield takeEvery(actions.GET_SAMPLE_EXAM_BY_ID, function* ({ payload }) {
		const { model } = payload;
		try {
			const response = yield call(mockTestService.getSampleExamById, model);
			if (response.data.success === true) {
				const { data } = response.data;
				yield put({
					type: actions.GET_SAMPLE_EXAM_BY_ID_SUCCESS,
					payload: data,
				});
			}
		} catch (e) {
			yield put({ type: actions.LOADING_FALSE });
		}
	});
}

export function* deleteSampleExam() {
	yield takeEvery(actions.DELETE_SAMPLE_EXAM, function* ({ payload, _success }) {
		const { model } = payload;
		try {
			yield call(mockTestService.deleteSampleExam, model);
			_success();
		} catch (e) {
			yield put({ type: actions.LOADING_FALSE });
		}
	});
}

export function* postSampleExam() {
	yield takeEvery(actions.POST_SAMPLE_EXAM, function* ({ payload, _success }) {
		const { model } = payload;
		try {
			yield call(mockTestService.postSampleExam, { ...model });
			_success();
		} catch (e) {
			yield put({ type: actions.LOADING_FALSE });
		}
	});
}

export function* getQuestionForCreate() {
	yield takeEvery(actions.GET_QUESTION_FOR_CREATE, function* ({ payload }) {
		const { model } = payload;
		try {
			const response = yield call(mockTestService.getQuestionForCreate, { QuestionType: model });
			if (response.data.success === true) {
				const { data } = response.data;
				yield put({
					type: actions.GET_QUESTION_FOR_CREATE_SUCCESS,
					payload: data,
				});
			}
		} catch (e) {
			yield put({ type: actions.LOADING_FALSE });
		}
	});
}

export function* putSampleExam() {
	yield takeEvery(actions.PUT_SAMPLE_EXAM, function* ({ payload, _success }) {
		const { model } = payload;
		try {
			yield call(mockTestService.putSampleExam, { ...model });
			_success();
		} catch (e) {
			yield put({ type: actions.LOADING_FALSE });
		}
	});
}

export function* getSpecialStudentsMockTest() {
	yield takeEvery(actions.GET_SPECIAL_STUDENTS_MOCKTEST, function* ({ payload }) {
		const { model } = payload;
		try {
			const response = yield call(mockTestService.getSpecialStundentsMockTest, model);
			if (response.data.success === true) {
				const { data } = response.data.data;
				yield put({
					type: actions.GET_SPECIAL_STUDENTS_MOCKTEST_SUCCESS,
					payload: { data },
				});
			}
		} catch (e) {
			yield put({ type: actions.LOADING_FALSE });
		}
	});
}

export function* postSpecialStudentsMockTest() {
	yield takeEvery(actions.POST_SPECIAL_STUDENTS_MOCKTEST, function* ({ payload, _success }) {
		const { model } = payload;
		try {
			yield call(mockTestService.addSpecialStundentsMockTest, { ...model });
			_success();
		} catch (e) {
			yield put({ type: actions.LOADING_FALSE });
		}
	});
}

export function* putSpecialStudentsMockTest() {
	yield takeEvery(actions.PUT_SPECIAL_STUDENTS_MOCKTEST, function* ({ payload, _success }) {
		const { model } = payload;
		try {
			yield call(mockTestService.putSpecialStundentsMockTest, { ...model });
			_success();
		} catch (e) {
			yield put({ type: actions.LOADING_FALSE });
		}
	});
}

export function* deleteSpecialStudentsMockTest() {
	yield takeEvery(actions.DELETE_SPECIAL_STUDENTS_MOCKTEST, function* ({ payload, _success }) {
		const { model } = payload;
		try {
			yield call(mockTestService.deleteSpecialStundentsMockTest, model);
			_success();
		} catch (e) {
			yield put({ type: actions.LOADING_FALSE });
		}
	});
}

export default function* rootSaga() {
	yield all([
		fork(getSampleExam),
		fork(getSampleExamById),
		fork(deleteSampleExam),
		fork(postSampleExam),
		fork(getQuestionForCreate),
		fork(putSampleExam),
		fork(getSpecialStudentsMockTest),
		fork(postSpecialStudentsMockTest),
		fork(putSpecialStudentsMockTest),
		fork(deleteSpecialStudentsMockTest),
	]);
}
